<script>
  import { cn } from '@lib/utils'
  
  let { children, header = false, striped = false, selected = false, class: className, ...rest } = $props()

  // cn("border-t border-gray-100 hover:bg-gray-50 cursor-pointer", 
  //             isSelected ? "bg-yellow-50/80 hover:bg-yellow-50/80 border-yellow-500" : "",
  let isClickable = $derived(typeof rest.onclick === "function")
  let baseClass = $derived(cn("relative", isClickable ? "hover:bg-gray-50 cursor-pointer" : ""))
  let headerClass = $derived(header ? "" : "")
  let stripedClass = $derived(striped ? "bg-blue-50" : "")
  let selectedClass = $derived(selected ? "bg-yellow-50/80" : "")
  
  let containerClass = $derived(cn(baseClass, headerClass, stripedClass, selectedClass, className))
</script>

<tr {...rest} class={containerClass}>
  {@render children?.()}
</tr>